// store/modules/music.js
// 音乐播放全局状态模块
// - currentSong: 当前播放歌曲对象
// - musicList: 当前歌单歌曲列表
// - currentIndex: 当前歌曲在 musicList 中的索引
// - isPlaying: 是否正在播放
// - playMode: 0=列表循环 1=单曲循环 2=随机播放
// - volume: 音量 (0-100)
// - showFloatingPlayer: 是否显示悬浮播放器
// - playerPosition: 悬浮播放器位置，始终使用 { left, top } 格式
// - currentTime / duration: 播放进度
// =================================================
const state = {
  currentSong: {},
  musicList: [],
  currentIndex: -1,
  isPlaying: false,
  playMode: 0,
  volume: 50,
  showFloatingPlayer: false,
  // 默认位置为右下角
  playerPosition: { left: '', top: '', right: '20px', bottom: '20px' },
  currentTime: 0,
  duration: 0
}

const mutations = {
  SET_CURRENT_SONG(state, song) {
    state.currentSong = song || {}
  },
  SET_MUSIC_LIST(state, list) {
    state.musicList = list || []
  },
  SET_CURRENT_INDEX(state, index) {
    state.currentIndex = index
  },
  SET_IS_PLAYING(state, val) {
    state.isPlaying = val
  },
  SET_PLAY_MODE(state, mode) {
    state.playMode = mode
  },
  SET_VOLUME(state, volume) {
    state.volume = volume
  },
  SET_SHOW_FLOATING(state, show) {
    state.showFloatingPlayer = show
  },
  SET_PLAYER_POSITION(state, pos) {
    state.playerPosition = Object.assign({}, state.playerPosition, pos)
  },
  INIT_PLAYER_POSITION(state) {
    if (typeof window === 'undefined') return
    const defaultLeft = Math.max(10, window.innerWidth - 300)
    const defaultTop = Math.max(10, window.innerHeight - 440)
    state.playerPosition = {
      left: defaultLeft + 'px',
      top: defaultTop + 'px',
      right: '',
      bottom: ''
    }
  },
  SET_CURRENT_TIME(state, t) {
    state.currentTime = t
  },
  SET_DURATION(state, d) {
    state.duration = d
  },
  TOGGLE_SHOW_FLOATING(state) {
    state.showFloatingPlayer = !state.showFloatingPlayer
  }
}

const actions = {
  // 播放指定歌曲
  playSong({ commit, state }, { song, index }) {
    if (!song || !song.songId) return

    // 如果未指定 index，查找是否已在列表中
    let realIndex = index
    if (realIndex === undefined || realIndex === null) {
      realIndex = state.musicList.findIndex(s => s.songId === song.songId)
      if (realIndex < 0) {
        // 列表中不存在，追加到末尾
        const newList = [...state.musicList, song]
        commit('SET_MUSIC_LIST', newList)
        realIndex = newList.length - 1
      }
    }

    commit('SET_CURRENT_INDEX', realIndex)
    commit('SET_CURRENT_SONG', song)
    commit('SET_IS_PLAYING', true)
  },
  playPrev({ commit, state }) {
    if (state.musicList.length === 0) return
    let idx
    if (state.playMode === 2) {
      // 随机播放
      do { idx = Math.floor(Math.random() * state.musicList.length) }
      while (idx === state.currentIndex && state.musicList.length > 1)
    } else {
      idx = state.currentIndex - 1
      if (idx < 0) idx = state.musicList.length - 1
    }
    commit('SET_CURRENT_INDEX', idx)
    commit('SET_CURRENT_SONG', state.musicList[idx])
    commit('SET_IS_PLAYING', true)
  },
  playNext({ commit, state }) {
    if (state.musicList.length === 0) return
    let idx
    if (state.playMode === 2) {
      do { idx = Math.floor(Math.random() * state.musicList.length) }
      while (idx === state.currentIndex && state.musicList.length > 1)
    } else {
      idx = state.currentIndex + 1
      if (idx >= state.musicList.length) idx = 0
    }
    commit('SET_CURRENT_INDEX', idx)
    commit('SET_CURRENT_SONG', state.musicList[idx])
    commit('SET_IS_PLAYING', true)
  },
  togglePlay({ commit, state }) {
    commit('SET_IS_PLAYING', !state.isPlaying)
  },
  // 播放模式切换（直接 commit，避免循环）
  setPlayMode({ commit }, mode) {
    commit('SET_PLAY_MODE', mode)
  },
  // 悬浮播放器显示/隐藏切换
  toggleFloating({ commit, state }) {
    commit('SET_SHOW_FLOATING', !state.showFloatingPlayer)
  }
}

const getters = {
  playModeText(state) {
    return ['列表循环', '单曲循环', '随机播放'][state.playMode]
  },
  progressPercent(state) {
    if (state.duration <= 0) return 0
    return (state.currentTime / state.duration) * 100
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
